export default "__VITE_ASSET__8PA92Bfk__"